/**
 * Returns an array with exceptions for the sentence beginning researcher.
 * @returns {Array} The array filled with exceptions.
 */
export default [
	// Indefinite articles:
	"אחד", "כמה", "מעטים",
	// Numbers 1-10 (feminine-masculine pairs):
	"אחת", "שנים", "שתים", "שלשה", "שלש", "ארבעה", "ארבע", "חמשה", "חמש", "ששה",
	"שש", "שבעה", "שבע", "שמונה", "שמונה", "תשעה", "תשע", "עשרה", "עשר",
	// Demonstrative pronouns:
	"זה", "זאת", "אלה", "אוה", "היא", "אלה", "המה", "הם", "הנה" ];

